import { HomeFooter } from '@/components/bluebird/Chrome'

/**
 * Compatibility wrapper for the legacy page layout.
 *
 * The Bluebird footer owns the actual markup so every public page exposes the
 * same location, newsletter, navigation, and review proof.
 */
export function Footer() {
  return (
    <div className="bluebird">
      <HomeFooter />
    </div>
  )
}
